"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStorageCycle = void 0;
const constants_1 = require("./constants");
const getStorageCycle = () => localStorage.getItem(constants_1.CYCLE_KEY);
exports.getStorageCycle = getStorageCycle;
